<template>
  <div class="layout/margin:top:page:2">
    <div
      class="
        $color/background:alpha:54%
        $color/background:gray:eee
        color/background
      "
      >
      <div
        class="
          layout/align:start
          layout/flex:column
          layout/grid:gap:page
          layout/padding:bottom:page
          layout/padding:top:page
          layout/wrapper
        "
        >
        <form
          class="
            layout/flex:column
            layout/grid:gap:page
            layout/width:100%
          "
          autocapitalize="none"
          autocomplete="off"
          autocorrect="off"
          action="/calendar/exhibitions/history/"
          accept-charset="UTF-8"
          method="get"
          @submit.prevent="onSubmit"
          >
          <SearchInput
            ref="input"
            :value="q"
            aria-label-input="Press return to search."
            aria-label-reset="Clear search terms."
            gtm="exhibition history / search"
            input-placeholder="Search exhibitions"
            @searchInput="(val) => $emit('search-input', val)"
            @searchReset="$emit('search-reset')"
          />
          <div
            class="
              @768/layout/grid:4
              layout/grid:2
              layout/align:center
              layout/grid:gap:page
              layout/width:100%
            "
            >
            <div
              class="
                layout/flex
                link/focus
              "
              >
              <Select
                id="mde_type"
                :value="mdeType"
                name="mde_type"
                aria-label="Filter by MDE type"
                :options="mdeTypeFilters"
                style="flex: 1;"
                @input="(val) => $emit('update-mde-type', val)"
              />
            </div>
            <div
              class="
                layout/flex
                link/focus
              "
              >
              <Select
                id="date-filter"
                :value="selectedDateSpanOption"
                aria-label="Filter by date"
                :options="dateSpanFilters"
                style="flex: 1;"
                @input="onDatespanChanged"
              />
            </div>
            <div
              class="
                layout/flex
                link/focus
              "
              >
              <Select
                id="location-filter"
                :value="location"
                name="location"
                aria-label="Filter by location"
                :options="locationFilters"
                style="flex: 1;"
                @input="(val) => $emit('update-location', val)"
              />
            </div>
            <div
              class="
                layout/flex
                link/focus
              "
              >
              <Select
                id="sort-date-filter"
                :value="sortDate"
                name="sort_date"
                aria-label="Filter by sort date"
                :options="sortDateFilters"
                style="flex: 1;"
                @input="(val) => $emit('update-sort-date', val)"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { options } from "./options";
import SearchInput from 'Components/form/search-input';
import Select from 'Components/form/select';

export default {
  components: {
    SearchInput,
    Select
  },

  props: {
    beginDate: { type: String, required: true },
    endDate: { type: String, required: true },
    location: { type: String, required: true },
    mdeType: { type: String, required: true },
    q: { type: String, required: true },
    sortDate: { type: String, required: true },
  },

  data() {
    return {
      mdeTypeFilters: options.mdeTypeOptions,
      dateSpanFilters: options.dateSpanOptions,
      dateSpanValueOptionToBeginEndDate: options.dateSpanOptions.reduce((acc, obj) => {
        acc[obj.value] = {
          begin_date: obj.begin_date,
          end_date: obj.end_date,
        };
        return acc;
      }, {}),
      locationFilters: options.locationOptions,
      sortDateFilters: options.sortDateOptions,
    };
  },

  computed: {
    /**
     * Finds option object in dataSpanFilters (arr of obj) with testing function against begin and end dates.
     *
     * The dateSpanFilter is of the form:
     *
     * [
     *  {
     *   "label": '1920s',
     *   "value": '1920',
     *   "begin_date": '1920',
     *   "end_date": '1929',
     *  },
     *  ...
     * ]
     *
     * Note: the date options are exceptional in the sense that a single value maps to two form values.
     *
     * @returns {string} The value of the "value" key inside the option object.
     */
    selectedDateSpanOption() {
      const option = this.dateSpanFilters.find(option =>
        (option.begin_date === this.beginDate
        && option.end_date === this.endDate
      ));
      return option.value;
    },
  },

  methods: {
    onDatespanChanged(val) {
      // Get the dateSpanFilter object in the map that is keyed by `val` (i.e. '1920').
      const beginEndDate = this.dateSpanValueOptionToBeginEndDate[val];

      this.$emit('update-datespan', {
        beginDate: beginEndDate.begin_date,
        endDate: beginEndDate.end_date,
      });
    },
    onSubmit() {
      this.$refs.input.blurInput();
      this.$emit('form-submit');
    }
  }
};
</script>
